import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

/*
	This file exists as part of the 'rovo_chat_jira_nl_to_jql_minion_in_fe' feature.
	It can be freely deleted if the feature is being removed.
*/

export const JIRA_NL_TO_JQL_CLIENT_ID: ClientId = client('jira-nl-to-jql');
